import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CominicationService {
  private subject = new Subject<any>();
  constructor() {}

  sendMessage(message: string, data?: any) {
    this.subject.next({ message: message, data: data });
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
